import Vue from "vue"
import router from "./router"
import moment from "moment-timezone"
import isurl from "is-url"
const methods = {
  //  methods: {
  verJson(data) {
    try {
      console.log(JSON.parse(JSON.stringify(data)))
    } catch (e) {
      console.log(data)
    }
  },
  toArray(valor) {
    if (valor === undefined) {
      return []
    }
    if (!Array.isArray(valor)) {
      return [valor]
    }
    return valor
  },
  showToasted(mensaje, tipo, duracion = 5000, clase) {
    Vue.toasted.show(mensaje, {
      theme: "toasted-primary",
      position: "top-right",
      duration: duracion,
      type: tipo, // error success info
      className: clase
    })
  },
  armarOcupacionCliente(adul, menores, filtarInfante = false) {
    const edades = this.toArray(menores.edades.edad).filter(e => {
      if (!filtarInfante) {
        return true
      }
      if (e > 2) {
        return true
      }
      return false
    })

    var stringmenores =
      edades.length > 0
        ? edades.length > 1
          ? " + " + edades.length + " Menores de " + edades.join() + " año/s"
          : "+ " + edades.length + " Menor de " + edades.join() + " año/s"
        : ""
    var adulto = adul > 1 ? adul.toString() + " Adultos" : adul.toString() + " Adulto"
    return adulto + stringmenores
  },
  _$goToInicio(valor = null) {
    let to = !localStorage.getItem("inicio-as") ? "inicio" : localStorage.getItem("inicio-as")
    if (valor != null) {
      to = valor
    }
    router.push({ name: to })
  },
  _$uniqueObjects(arr, comp) {
    const unique = arr
      .map(e => e[comp])

      // guarda el key de los arrays
      .map((e, i, final) => final.indexOf(e) === i && i)

      // Emilina duplicados y guarda los unicos
      .filter(e => arr[e])
      .map(e => arr[e])

    return unique
  },
  _$diffDias(inicio, fin) {
    const desde = moment(inicio)
    const hasta = moment(fin)
    const cantidad = hasta.diff(desde, "days")
    let unidad = "noches"
    if (cantidad == 1) {
      unidad = "noche"
    }
    return `${cantidad} ${unidad}`
  },
  _$isUrl(toTest) {
    return isurl(toTest)
  },
  _$toBotonCarrito(texto, goto, variante, disabled, visible = true) {
    return {
      visible: visible,
      texto: texto,
      goto: goto,
      classObject: {
        "v-btn--disabled": disabled,
        orange: disabled,
        "blue darken-2": !disabled,
        caption: true
      }
    }
  },
  _$toBoolean(valor) {
    return valor === true
  },
  _$yyyymmdd2Date(valor) {
    if (valor === null) {
      return valor
    }
    const fecha = new Date(valor)
    const utc = Date.UTC(fecha.getUTCFullYear(), fecha.getUTCMonth(), fecha.getUTCDate())
    if (fecha === "Invalid Date") {
      return null
    }
    return fecha
  },
  _$goToUrl(url, onTab = true) {
    if (onTab) {
      let win = window.open(url, "_blank")
      win.focus()
      return
    }
    window.location.href = url
  },
  _$formatDMY(value) {
    var date = moment.tz(value, "America/Argentina/Buenos_Aires")
    var formateado = date.locale("es").format("DD-MM-YYYY")
    return formateado.charAt(0).toUpperCase() + formateado.slice(1)
  },
  _$fechasNoDisponiblesBuscadores(inicio, min, max) {
    const desde = moment(inicio)
    const inicioHabilitado = moment(inicio).clone()
    let rangoMaximoDeshabilitado = []
    let habilitados = []
    for (var i = 0; i < max; i++) {
      habilitados.push(inicioHabilitado.add(1, "days").clone())
    }
    for (var i = 0; i < 365; i++) {
      const fecha = desde.add(1, "days").clone()
      const isIn = habilitados.findIndex(r => r.diff(fecha, "days") == 0)
      if (isIn === -1) {
        rangoMaximoDeshabilitado.push(fecha.toDate())
      }
    }
    let inicioDeshabilitado = habilitados.slice(0, min)
    inicioDeshabilitado.push(moment(inicio))
    return { rangoMaximoDeshabilitado, inicioDeshabilitado }
  }
}
export default {
  methods
}
